import React, { Component } from 'react';
import { extendedDateFormat } from '../../../utils/format'

import {
    Link,
} from 'react-router-dom';

class SessionsTable extends Component {
    render() {
        const { data = [] } = this.props;
        return (
            <table>
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Pool Reference</th>
                        <th>Created</th>
                        <th className="wf-btn-cell"></th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((d, i) => {
                        return (
                            <tr key={`users-${i}`}>
                                <td>{d.email}</td>
                                <td>{d.pool_reference}</td>
                                <td>{extendedDateFormat(d.created_at)}</td>
                                <td className="wf-btn-cell">
                                    <Link to={`/sessions/${d.session}`}><button className="wf-btn-sm">View</button></Link>
                                </td>
                            </tr>
                        )
                    })}

                    {data.length === 0 &&
                        <tr key={`users`}>
                            <td colSpan={4}>No Sessions</td>
                        </tr>
                    }
                    
                </tbody>
            </table>
        );
    }
}

export default SessionsTable;
